module.exports = __webpack_public_path__ + "img/children-of-blood-and-bone.0812b4bf.png";